import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useDashboardService } from 'src/apis/dashboard/useDashboardService';
import { IAttendanceDashboardData } from 'src/apis/dashboard/dashboardAttendance.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getDashboardAttendanceKey = 'get-dashboard-attendance';

export const useDashboardAttendanceHook = (
  options?: UseQueryOptions<IAttendanceDashboardData, TQueryError>
): UseQueryResult<IAttendanceDashboardData, TQueryError> => {
  const { getAttendanceDashboardData } = useDashboardService();

  return useQuery<IAttendanceDashboardData, TQueryError>({
    queryKey: [getDashboardAttendanceKey],
    queryFn: () => getAttendanceDashboardData(),
    enabled: true,
    ...options,
  });
};
